import React from 'react'
import { ToolkitPageLayout } from '../ToolkitPageLayout'
import { processToolkitContent } from '../../utils/contentProcessor'
import { BreadcrumbItem } from '../../types/toolkit.types'

interface ToolkitContentPageProps {
  title: string
  htmlContent: string
  breadcrumbs?: BreadcrumbItem[]
}

export const ToolkitContentPage: React.FC<ToolkitContentPageProps> = ({
  title,
  htmlContent,
  breadcrumbs
}) => {
  const processedContent = processToolkitContent(htmlContent)

  return (
    <ToolkitPageLayout title={title} breadcrumbs={breadcrumbs}>
      {/* Content */}
      <div
        className="prose prose-lg max-w-none prose-headings:text-[#3C2416] prose-p:text-[#142841] prose-a:text-[#A6410A] hover:prose-a:text-[#894d35] prose-strong:text-[#3C2416] prose-ul:text-[#142841] prose-ol:text-[#142841]"
        dangerouslySetInnerHTML={{ __html: processedContent.html }}
      />

      {/* Additional Resources if any links found */}
      {processedContent.links.length > 0 && (
        <div className="mt-12 p-6 bg-[#EDE6DE] rounded-lg">
          <h3 className="text-xl font-bold text-[#3C2416] mb-4">
            Additional Resources
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {processedContent.links.slice(0, 6).map((link, index) => (
              <a
                key={index}
                href={link}
                target="_blank"
                rel="noopener noreferrer"
                className="block p-4 bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow duration-200 border border-[#A0B2B4]"
              >
                <span className="text-[#A6410A] hover:text-[#894d35] font-medium">
                  External Resource {index + 1}
                </span>
              </a>
            ))}
          </div>
        </div>
      )}

      {/* Documents if any found */}
      {processedContent.documents.length > 0 && (
        <div className="mt-8 p-6 bg-[#EDE6DE] rounded-lg">
          <h3 className="text-xl font-bold text-[#3C2416] mb-4">
            Documents & Downloads
          </h3>
          <div className="space-y-3">
            {processedContent.documents.map((doc, index) => (
              <a
                key={index}
                href={doc}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center p-3 bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow duration-200 border border-[#A0B2B4]"
              >
                <div className="w-8 h-8 bg-[#A6410A] rounded-lg flex items-center justify-center mr-3">
                  <svg
                    className="w-4 h-4 text-white"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"
                      clipRule="evenodd"
                    />
                  </svg>
                </div>
                <span className="text-[#3C2416] font-medium">
                  Document {index + 1}
                </span>
              </a>
            ))}
          </div>
        </div>
      )}
    </ToolkitPageLayout>
  )
}
